import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/api-client';
import { parsePhraseRecordingStats } from './phrase-recording-stats';

export const usePhraseRecordingStats = (fileId: number, enabled: boolean) =>
  useQuery({
    queryKey: ['admin', 'phrase-recording-stats', fileId],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<unknown>(`/words/${fileId}/phrase-stats`, { signal });
      return parsePhraseRecordingStats(data);
    },
    enabled,
    staleTime: 60_000,
  });
